<template>
  <section class="section">
    <div class="container no-print">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            DASM/ ການຕິດຕາມສັນຍາຈັດຊື້
           
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 6 || roleid == 7">
        <b-tab-item label="ລູກຄ້າ">
          <div class="columns scrollme">
            <div class="column" >
              <b-field>
                <div class="columns" style=" display: flex">
                  <div class="column">
                    <div style="font-size:18px; font-weight: bold; margin-bottom: 20px">ລາຍການລູກຄ້າ</div>    
                    
                    <table class="table is-fullwidth is-narrow is-small">
                      <thead>
                        <tr>
                          <th class="has-text-centered " width="3%">#</th>

                          <th class="has-text-left " width="30%">
                            ບໍລິສັດ | ຊື່ | Username
                          </th>
                          <th class="has-text-centered " width="67%">
                            ຈັດການ
                          </th>
                          
                          
                          
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in customerList"
                          :key="data.ID"
                        >
                          <td class="has-text-centered">{{ index +1 }}
                          </td>

                          <td>
                            {{data.COMPANYNAME}} | {{data.FULLNAME}} | {{data.USERNAME}}
                          </td>
                          <td class="has-text-centered">
                            <b-button
                              class="btn-group-margin"
                              type="is-info"  
                              @click="
                                productUsageList(data.USERNAME, data.COMPANYNAME)
                              "
                              >ລາຍການສິນຄ້າ
                            </b-button>

                            <b-button v-if="data.B2BTYPE ==3"
                              class="btn-group-margin"
                              type="is-success" 
                              @click="
                                getProductFixPriceList(data.USERNAME, data.COMPANYNAME)
                              "
                              >ຕັ້ງລາຄາ
                            </b-button>
                            <b-button v-else
                              disabled
                              class="btn-group-margin"
                              type="is-success" 
                              @click="
                                getProductFixPriceList(data.USERNAME, data.COMPANYNAME)
                              "
                              >ຕັ້ງລາຄາ
                            </b-button>
                          </td> 
                                                        
                        </tr>
                      </tbody>
                      
                    </table>
                  </div>
                </div>
              </b-field>
            </div>
          </div>
          
        </b-tab-item>

        <b-tab-item label="ລາຍການສິນຄ້າ">
          <div>
            ລູກຄ້າ: <span style="font-weight: bold;"> {{  customerCompany }}</span> 
          </div>
          <b-tabs v-model="activeTabProduct" >
            
            <b-tab-item label="ລາຍການສິນຄ້າ">
              <div class="columns">
                <div class="column" style="padding-right:50px;">
                  <b-field grouped>
                    <b-field>
                      <b-datepicker
                        :date-formatter="dateFormatter"
                        v-model="productStartDate"
                      >
                      </b-datepicker>
                    </b-field>
                  </b-field>
                </div>
                <div class="column" style="padding-right:50px;">
                  <b-field grouped>
                    <b-field>
                      <b-datepicker
                        :date-formatter="dateFormatter"
                        v-model="productEndDate"
                      >
                      </b-datepicker>
                    </b-field>
                  </b-field>
                </div>

                <div class="column" style="padding-right:50px;">
                  <b-field>
                    <Multiselect
                      placeholder="ເລືອກສິນຄ້າ"
                      v-model.trim="selectedProduct"
                      label="PRODUCTNAME_SUB"
                      track-by="PRODUCTID_SUB"
                      :options="productList2"
                    >
                    </Multiselect>
                  </b-field>
                </div> 

                <div class="column">
                  <b-field>
                    <b-button
                      class="btn-group-margin"
                      type="is-info"
                      @click="productUsageList()"
                      >ເບິ່ງຂໍ້ມູນ
                    </b-button>
                  </b-field>
                </div>
              
              </div>
              <div class="columns">
                <div class="column" >
                  <div style="font-size:18px; font-weight: bold; margin-bottom: 20px">ການນຳໃຊ້ສິນຄ້າ</div>    
                    <table class="table is-fullwidth is-narrow is-small">
                      <thead>
                        <tr>
                          <th class="has-text-centered " width="3%">#</th>

                          <th class="has-text-left " width="30%">
                            ຊື່ສິນຄ້າ
                          </th>
                          <th class="has-text-right " width="20%">
                            ລວມຈຳນວນ<br>ທີ່ໃຊ້
                          </th>
                          <th class="has-text-right " width="2+0%">
                            ລາຄາສະເລ່ຍ
                          </th>
                          <th class="has-text-centered " width="20%">
                            ລາຍລະອຽດ
                          </th>
                          
                          
                          
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in productList"
                          :key="data.ID"
                        >
                          <td class="has-text-centered">{{ index +1 }}
                          </td>

                          <td class="has-text-left">
                            {{data.PRODUCTNAME_SUB}} 
                          </td>
                          <td class="has-text-right">
                            {{data.TOTALQUANTITY | formatNumberLocal}} 
                          </td>
                          <td class="has-text-right">
                            {{data.AVERAGEPRICE | formatNumberLocal}} 
                          </td>
                          <td class="has-text-centered">
                            <b-button
                              class="btn-group-margin"
                              type="is-info"  
                              size="is-small"
                              @click="
                                productUsageDetail(data)
                              "
                              >ລາຍລະອຽດ
                            </b-button>
                          </td> 
                                                        
                        </tr>
                      </tbody>
                      
                    </table>
                </div>
              </div>
            </b-tab-item>

            <b-tab-item label="ລາຍລະອຽດສິນຄ້າ">
              <div class="columns">
                <div class="column">
                  <table class="table is-fullwidth is-narrow is-small">
                      <thead>
                        <tr>
                          <th class="has-text-centered " width="3%">#</th>

                          <th class="has-text-left " width="20%">
                            ຊື່ສິນຄ້າ
                          </th>
                          <th class="has-text-left " width="10%">
                            ວັນທີ
                          </th>
                          <th class="has-text-right " width="20%">
                            ຈຳນວນ
                          </th>
                          <th class="has-text-right " width="20%">
                            ລາຄາ
                          </th>
                          
                          
                          
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in productDeatilList"
                          :key="data.ID"
                        >
                          <td class="has-text-centered">{{ index +1 }}
                          </td>
                          <td class="has-text-left">
                            {{data.PRODUCTNAME_SUB}} 
                          </td>
                          <td class="has-text-left">
                            {{dateFormatter(data.REDATE)}} 
                          </td>
                          
                          <td class="has-text-right">
                            <span style="font-weight: bold;">{{data.QUANTITY | formatNumberLocal}}</span> {{ data.UNIT }}
                          </td>
                          <td class="has-text-right">
                            {{data.PRICE | formatNumberLocal}} 
                          </td>
                          
                                                        
                        </tr>
                      </tbody>
                      <tfoot>
                    <tr>
                      <th colspan="3" class="has-text-centered">
                        ລວມ
                        {{ productDeatilList.length | formatNumberLocal }}
                        ລາຍການ
                      </th>
                      <th class="has-text-right">
                        <span style="font-weight: bold;">
                          {{
                            _.sumBy(productDeatilList, (i) => i["QUANTITY"] * 1)
                              | formatNumberLocal
                          }}
                        </span>
                        
                          {{ productDeatilList.length > 0 ? productDeatilList[0].UNIT : '' }}
                      </th>
                      <th  class="has-text-right">
                        {{
                          (_.sumBy(productDeatilList, (i) => i["QUANTITY"] * i["PRICE"]) /
                          _.sumBy(productDeatilList, (i) => i["QUANTITY"] * 1))
                          | formatNumberLocal
                        }}
                      </th>
                    </tr>
                  </tfoot>
                      
                    </table>
                </div>
              </div>
            </b-tab-item>
          </b-tabs>
              
        </b-tab-item>
        <b-tab-item label="ຕັ້ງລາຄາ"> 
          <div>
            ລູກຄ້າ: <span style="font-weight: bold;"> {{  customerCompany }}</span> 
          </div>
  
          <div class="columns" style="margin-top: 1px;">
            <div class="column">
              <div style="font-weight: bold;">ຕັ້ງລາຄາ ສິນຄ້າ</div>    
            </div>
            <div class="column"></div>


       
            <div class="column" style="padding-right:50px;">
              <b-field grouped>
                <b-field >
                  <b-datepicker
                    :date-formatter="dateFormatter"
                    v-model="priceStartDate"
                  >
                  </b-datepicker>
                </b-field>
              </b-field>
            </div>
            <div class="column" style="padding-right:50px;">
              <b-field grouped>
                <b-field >
                  <b-datepicker
                    :date-formatter="dateFormatter"
                    v-model="priceEndDate"
                  >
                  </b-datepicker>
                </b-field>
              </b-field>
            </div>

            <div class="column">
              <b-field>
                <b-button
                  class="btn-group-margin"
                  type="is-primary"
                  @click="print()"
                  >ພິມໃບລາຄາ
                </b-button>
              </b-field>
            </div>
              
            <div class="column"></div>     

            <div class="column" style="text-align: right">
              <b-button
                  class="btn-group-margin"
                  type="is-info"
                  @click="saveProductFixPrice()"
                >ບັນທຶກລາຍການ
              </b-button>   
            </div>
          </div>     
         
          <div class="columns" style="margin-top: -30px;">

            <div class="column">
              
              
              <table class="table is-fullwidth is-narrow is-small">
                <thead>
                  <tr>
                    <th class="has-text-centered " width="3%">#</th>

                    <th class="has-text-left " width="30%">
                      ຊື່ສິນຄ້າ
                    </th>
                    <th class="has-text-centered " width="5%">
                      ຫົວໜ່ວຍ
                    </th>
                    <th class="has-text-right " width="15%">
                      ລາຄາຂາຍທົ່ວໄປ
                    </th>
                    <th class="has-text-right " width="15%">
                      ລາຄາປະຈຸບັນ
                    </th>
                    <th class="has-text-centered " width="15%">
                      ກຳນົດລາຄາ
                    </th>
                    <th class="has-text-centered " width="10%">
                      ຈັດການ
                    </th>
                    
                    
                    
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in fixPriceProductList"
                    :key="data.ID"
                  >
                    <td class="has-text-centered">{{ index +1 }}
                    </td>

                    <td class="has-text-left ">
                      {{data.PRODUCTNAME_SUB}}
                    </td>
                    <td class="has-text-centered ">
                      {{data.UNIT}}
                    </td>
                    <td class="has-text-right">
                      {{ data.GENERALPRICE | formatNumberLocal }}
                    </td> 
                    <td class="has-text-right">
                      {{ data.PRICE  | formatNumberLocal }}
                    </td> 

                    <td class="has-text-right">
                      <b-input width="100px"
                        v-model.trim="data.PRICE2"
                        type="number"
                      step="any"
                      >  
                      </b-input> 
                    </td> 
                    <td class="has-text-centered">
                      <b-button
                        class="btn-group-margin"
                        type="is-info"
                        size="is-small"
                        @click="saveProductFixPrice()"    
                      >ບັນທຶກ
                    </b-button> 
                    </td> 
                                                  
                  </tr>
                </tbody>
                    
                  </table>
                </div>
              </div>
           
          
        </b-tab-item>
        <b-tab-item label="ຕິດຕາມຍອດຂາຍ">
          <div class="columns" style="margin-bottom: -70px;">
            <div class="column" >

            </div>
            <div class="column">
              <b-field grouped  style="float: right;"> 
                <b-field>
                  <b-button
                      class="btn-group-margin"
                      type="is-info"
                      size="is-small"  
                      @click="sortCustomerData('INMOUNTH', 'desc')"
                    > ລຽງຕາມ ໃນເດືອນ
                  </b-button> 
                </b-field>
                <b-field>
                  <b-button
                      class="btn-group-margin"
                      type="is-info"
                      size="is-small"  
                      @click="sortCustomerData('SELLTOTAL7DAYS', 'desc')"
                    > ລຽງຕາມ 7 ວັນລ່າສຸດ
                  </b-button> 
                </b-field>
                <b-field>
                  <b-button
                      class="btn-group-margin"
                      type="is-info"
                      size="is-small"  
                      @click="sortCustomerData('SELLTOTAL30DAYS', 'desc')"
                    > ລຽງຕາມ 30 ມື້ຖັດໄປ  
                  </b-button> 
                </b-field>
              </b-field>
            </div>
          </div>
          <div class="columns scrollme">
            <div class="column" >
              <b-field>
                <div class="columns" style=" display: flex">
                  <div class="column">
                    <div style="font-size:18px; font-weight: bold; margin-bottom: 20px">ຕິດຕາມຍອດຂາຍ</div>    
                    
                    <table class="table is-fullwidth is-narrow is-small">
                      <thead>
                        <tr>
                          <th class="has-text-centered border" width="3%" style="vertical-align: middle;"  rowspan="2">#</th>

                          <th class="has-text-left border"  width="40%" style="vertical-align: middle;"  rowspan="2">
                            ລູກຄ້າ
                          </th>
                          <th class="has-text-centered border" width="57%" colspan="3">
                            ຍອດຂາຍ
                          </th>
                          
                          
                          
                        </tr>
                        <tr>
                          <th class="has-text-centered border">
                            ໃນເດືອນ
                          </th>
                          <th class="has-text-centered border">
                            7 ວັນລ່າສຸດ
                          </th>
                          <th class="has-text-centered border">
                            30 ມື້ຖັດໄປ
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in customerSellAMountList"
                          :key="data.ID"
                        >
                          <td class="has-text-centered border">{{ index +1 }}
                          </td>

                          <td class="has-text-left border">
                            {{data.COMPANY}} 
                          </td>
                          <td class="has-text-right border">
                            {{data.INMOUNTH | formatNumberLocal}} 
                          </td> 
                          <td class="has-text-right border">
                            {{data.SELLTOTAL7DAYS | formatNumberLocal}} 
                          </td> 
                          <td class="has-text-right border">
                            {{data.SELLTOTAL30DAYS | formatNumberLocal}} 
                          </td> 
                                                        
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <th colspan="2" class="has-text-right set-border">
                            ລວມ
                            {{ customerSellAMountList.length | formatNumberLocal }} ລາຍການ
                          </th>
                          <th class="has-text-right set-border">
                            {{
                              _.sumBy(customerSellAMountList, (i) => i["INMOUNTH"] * 1)
                                | formatNumberLocal
                            }}
                          </th>
                          <th class="has-text-right set-border">
                            {{
                              _.sumBy(customerSellAMountList, (i) => i["SELLTOTAL7DAYS"] * 1)
                                | formatNumberLocal
                            }}
                          </th>
                          <th class="has-text-right set-border">
                            {{
                              _.sumBy(customerSellAMountList, (i) => i["SELLTOTAL30DAYS"] * 1)
                                | formatNumberLocal
                            }}
                          </th>
                        </tr>
                      </tfoot>
                                        
                    </table>
                  </div>
                </div>
              </b-field>
            </div>
          </div>
          
        </b-tab-item>
      </b-tabs>
    </div>

    <div class="contain print-only page-break">
      <div class="contain">
        <div class="columns">  
          <div class="column">
            <div
              style=" padding: 0 0 0 0; margin: 0 0 0 0 ;"
            >
              <img
                class="image-area"
                style="width: 70px;"
                :src="getImgUrl('logo/agrilaologo.png')"
                alt="Placeholder image"
              />    
            </div>
            <div class="columns">
              <div class="column" style="">
                <div style="font-size: 12px;">
                  Agrilao Innovation Ordinary Partnertship
                </div>
                <div style="font-size: 12px;">
                  Address: Dongdok-Sikuert Road,
                </div>
                <div style="font-size: 12px; padding-left: 50px;">
                  Sikhottabong Distirct, Vientiane Capital, Laos
                </div>
                <div style="font-size: 12px;">
                  Contact No: +85620 55333483, +85620 28040508
                </div>
                <div style="font-size: 12px;">
                  Email: argilao.lpdr@gmail.com
                </div>
              </div>
      
              <div class="column" style="text-align: right;">   
                <div>
                  
                  <span>Date:
                    {{ dateFormatter(currentDate) }}
                  </span
                >
                </div>
                
              </div>
            </div>

            
            <div style="margin-top: 0px; text-align: center;">
              <div style="font-size: 24px; font-weight: bold">
                <span > ໃບແຈ້ງລາຄາສິນຄ້າ  ({{ customerCompany }})<br> 
                  <span style="font-size: 16px; ">ລະຫວ່າງວັນທີ: {{ dateFormatter(priceStartDate) }} ເຖິງ {{ dateFormatter(priceEndDate) }}</span><br>  
                  
                  
                </span>
                
                
                
              </div>
            </div>  
          </div>
        </div>
        
        <div class="columns" >  
          <div class="column">
            
            <div style="height: 10px;"></div>

            <table
              class="table is-fullwidth is-narrow is-small"
             
            >
              <thead>  
                <tr style="height: 50px;">
                  <th
                    class="has-text-centered set-border"
                    width="5%"
                    style="vertical-align: middle;"
                  >
                    ລ/ດ
                  </th>
                  <th
                    class="has-text-left set-border"
                    width="30%"
                    style="vertical-align: middle;"
                  >
                    ຊື່ສິນຄ້າ
                  </th>
                  <th
                    class="has-text-centered set-border"
                    width="10%"
                    style="vertical-align: middle;"
                  >
                    ຫົວໜ່ວຍ
                  </th>
                  <th
                    class="has-text-right set-border"
                    width="20%"
                    style="vertical-align: middle;"
                  >
                    ລາຄາຂາຍ
                  </th>
                  
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in filteredFixPriceProductList"
                  :key="data.ID"
                >
                  <td class="has-text-centered set-border">{{ index + 1 }}</td>

                  <td  class="set-border">
                    {{data.PRODUCTNAME_SUB}} 
                  </td>
                  <td class="has-text-centered set-border">
                    {{ data.UNIT  }}
                  </td>
                  <td class="has-text-right set-border">
                    {{ data.PRICE | formatNumberLocal }}
                  </td>
                </tr>
              </tbody>
            </table>

            
          </div>
        </div>
        <div class="columns" style="page-break-inside: avoid;" >
          <div class="column">
            <div>
              
            </div>
            
            
          </div>   
          
          <div
            class="column"
            style="text-align: center; font-weight: bold; font-size: 16px;"
          >
            <div style="text-align: center;">
              <div>
                Agrilao Innovation Ordinary Partnership<br> 
                Deputy Managing Director<br>
              </div>
              
              
              <b-field >
                <b-field style="text-align: right;">
                  <img 
                    class="image-area"  
                    style=""
                    :src="getImgUrl('sign/deputymanagingdirector.png')"
                    alt="Placeholder image"
                  />
                </b-field>
                  
              </b-field>  
              
            </div> 
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";
// import axios from "axios";


// import { BFormSelect } from 'bootstrap-vue'



export default {
  // components: { Multiselect, BFormSelect},
  components: { Multiselect},

  props: ["MONTH"],
  data() {
    return {
      roleid: null,
      currentDate: null,
      customerUsername: null,
      customerCompany: null,

      activeTab:0,
      activeTabProduct: 0,

      

      customerList: [],
      productStartDate: null,
      productEndDate: null,
      priceStartDate: null,
      priceEndDate: null,
      productList: [],
      productList2: [],
      selectedProduct: null,

      productDeatilList: [],

      fixPriceProductList: [],

      photopath:
        process.env.NODE_ENV === "production"
          ? "https://agrilao.com/manager-main/api/uploads/"
          : "http://localhost/agrilao-manager-v2/api/uploads/",

      customerSellAMountList: [],
    };
    
    
  },
  methods: {      

    getCustomerSell7Days(){
      RestAPI.getCustomerSell7Days(this.username)
      .then((res) => {
        this.customerSellAMountList = res.data;
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },
    sortCustomerData(key, order = 'desc') {
      this.customerSellAMountList = _.orderBy(
          this.customerSellAMountList,
          [(data) => parseFloat(String(data[key]).replace(/,/g, ''))], // Convert to number
          [order]
        );
      },
    saveProductFixPrice(){
      this.$swal({
          title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",  
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.value) {
    

            var params = {
              data: this.fixPriceProductList,  
              b2busername: this.b2busername,
              username: this.username,    
            };
            // console.log("pararms: " + JSON.stringify(params))  
            const loadingComponent = this.$loading.open({});
            RestAPI.saveProductFixPrice(params)
              .then(() => {
                this.fixPriceProductList = [];
                this.getProductFixPriceList();
              })  
              .catch((error) => {
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                } 
              });

            loadingComponent.close();

          }
        });
    },

    getProductFixPriceList(customerusername = null, company = null){
      this.activeTab = 2;
      this.customerUsername = customerusername == null ? this.customerUsername : customerusername;
      this.customerCompany = company;
      RestAPI.getProductFixPriceList(this.customerUsername)
      .then((res) => {
        this.fixPriceProductList = res.data;
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },

    productUsageDetail(data){
      this.activeTabProduct = 1;
      // console.log("data: " + JSON.stringify(data))
      RestAPI.getCustomerProductDetail(this.customerUsername, data.PRODUCTID_SUB , this.dateFormatterYYYYMMDD(this.productStartDate), this.dateFormatterYYYYMMDD(this.productEndDate))
      .then((res) => {
        this.productDeatilList = res.data;
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },
    
    productUsageList(customerusername = null, company = null){
      this.customerUsername = customerusername == null ? this.customerUsername : customerusername;
      this.customerCompany = company;
      var selectedProductid = this.selectedProduct ? this.selectedProduct.PRODUCTID_SUB: 0;
      this.activeTab = 1;
      RestAPI.getCustomerProductList(this.customerUsername, selectedProductid, this.dateFormatterYYYYMMDD(this.productStartDate), this.dateFormatterYYYYMMDD(this.productEndDate))
      .then((res) => {
        this.productList = res.data;
        if(!this.selectedProduct){
          this.productList2 = res.data;
        }
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },

    getCustomerList(){
      
      RestAPI.getDASMB2bUserForCustomer()
      .then((res) => {
        this.customerList = res.data;
      })
      
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },



    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateTimeFormatter(date) {      
      // return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "";  
      return new moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },

    getImgUrl(photoname) { 
      var photopreview = photoname
        ? this.photopath + photoname
        : this.photopath + "unknown.png";
      return photopreview;
    },
 
    print() {
        window.print(); 
    },
    

    

  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;

    this.currentDate = new Date();

    this.getCustomerList();
    this.getCustomerSell7Days();

    this.startDate = new Date(
      this.currentDate.getFullYear(),
      this.currentDate.getMonth(),
      1
    );
    this.endDate = new Date(
      this.currentDate.getFullYear(),
      this.currentDate.getMonth() + 1,
      0
    );

    this.productStartDate = this.startDate;
    this.productEndDate = this.endDate;

    this.priceStartDate = this.startDate;
    this.priceEndDate = this.endDate;

    // this.stockOutDate =  new Date(this.currentDate);

    // this.productStockOutTxdate =  new Date(this.currentDate);
    // this.productStockOutTxdateByProduct =  new Date(this.currentDate);
    
    // this.getStockVenderList();
    // this.getStockProductList();
    // this.getStockHistory();
    // this.getProductinStock();
    // this.getRemainProduct();
    // this.getProductInStockSummary();
    // this.getProductInStockSummaryForOrder();
    // this.getProductStockOutHistory();
    // this.getProductStockOutHistoryByProduct();
    

  },

  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },

    filteredFixPriceProductList() {
    return this.fixPriceProductList.filter((data) => data.PRICE > 0);
  }

   
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.border {
    border: 1px solid black;  
    padding: 8px;
    text-align: center;
  }
.popup {
  display: block;
  position: fixed;
  z-index: 1;
  padding-top: 60px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
}
/* Style for the popup content (image) */
.popup-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add animation (optional) */
.popup-content {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}
.receipt-highigt{
  font-weight: bold;
}
.custom-flex-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 5px; /* Optional: adds some spacing between the items */
}

.product-name {
  width: 100%; /* Forces the field to take full width on small screens */
  margin-top: 5px; /* Optional: adds some top margin */
}

@media (min-width: 768px) {
  .product-name {
    width: auto; /* Restores the default behavior on larger screens */
    margin-top: 0;
  }
}
.column-35 {
  flex: 0 0 20%;
}
.column-65 {
  flex: 0 0 80%;
}


.column-40 {
  flex: 0 0 35%;
}
.column-60 {
  flex: 0 0 65%;
}

.asterisk {
  color: red;
}
  
.table {
  border-collapse: collapse;
  width: 100%;
}

.set-border {
  border: 1px solid #838282;
}

tbody tr:last-child td {
  border-bottom: 1px solid #838282 !important;
}


tbody tr:last-child td {
  border-bottom: 1px solid #000; /* Specifically target the last row's bottom border */
}

.summary-footer {
  page-break-before: always;
}

.modal {  
  display: none;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

/* Style for the modal content */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

/* Style for the close button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

@media print {
  @page {
    margin-top: 0; /* Set the initial margin for the first page */
  }
}
</style>
